// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const forums = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_CATEGORY':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_DATA_LIST_REPORT':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
      case 'GET_DATA_LIST_STREAMING':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
          params: action.params,
          from: action.from,
          to: action.to,
        }
      case 'GET_DATA_LIST_BANNER':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
          params: action.params,
          from: action.from,
          to: action.to,
        }
      case 'GET_DATA_REPORT':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
          params: action.params,
          from: action.from,
          to: action.to,
        }
    case 'GET_DATA_STATISTIC':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_STATISTIC':
      return { ...state, selectedData: action.selectedData }
    case 'GET_CATEGORY':
      return { ...state, selectedData: action.selectedData }
    case 'SHOW_STREAMING':
      return { ...state, selectedData: action.selectedData }
    case 'SHOW_BANNER':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_CATEGORY':
      return { ...state }
    case 'EDIT_CATEGORY':
      return { ...state }
    case 'DELETE_CATEGORY':
      return { ...state }
    default:
      return { ...state }
  }
}
export default forums
